import React from 'react';
import ContractCard from './ContractCard';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';



const ContractGrid = ({ contracts, onQuickAction, selectedContracts, onSelectContract }) => {
  if (contracts?.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="FileText" size={24} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-medium text-foreground mb-2">No contracts found</h3>
        <p className="text-muted-foreground mb-6">
          Try adjusting your filters or create a new contract to get started.
        </p>
        <Button
          variant="default"
          iconName="Plus"
          iconPosition="left"
        >
          Create New Contract
        </Button>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {contracts?.map((contract) => (
        <div key={contract?.id} className="relative">
          {/* Selection Checkbox */}
          <div className="absolute top-4 left-4 z-10">
            <input
              type="checkbox"
              checked={selectedContracts?.includes(contract?.id)}
              onChange={(e) => onSelectContract(contract?.id, e?.target?.checked)}
              className="w-4 h-4 text-primary bg-background border-border rounded focus:ring-primary focus:ring-2"
            />
          </div>
          
          <ContractCard
            contract={contract}
            onQuickAction={onQuickAction}
          />
        </div>
      ))}
    </div>
  );
};

export default ContractGrid;